<script setup lang="ts">
import type { Ref, RendererElement } from "vue";

withDefaults(
  defineProps<{
    controller: { isOpen: Ref<boolean>; updateRef: (ref: HTMLElement) => void };
    teleportTo?: "body" | RendererElement | null;
  }>(),
  { teleportTo: "body" },
);
</script>

<template>
  <Teleport v-if="controller.isOpen.value" :to="teleportTo">
    <div :ref="(el) => controller.updateRef(el as HTMLElement)" class="action-menu-container">
      <!-- stop pointerdown so that we don't enter multiSelect mode -->
      <div class="action-menu" data-ignore-click tabindex="-1" @pointerdown.stop>
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
@use "@/styles/z-index";
@use "@/styles/variables/colors";
@use "./action-menu";

.action-menu-container {
  z-index: z-index.$action-menu;

  .action-menu {
    background-color: colors.$background-ui-inverse;
    display: inline-flex;
    border-radius: 10px;
    overflow: hidden;

    :deep(.base-button.ghost.grey:not(.action-menu-dropdown .wrapper .base-button)),
    :deep(.icon-button:not(.action-menu-dropdown .wrapper .icon-button)) {
      @include action-menu.action-menu;
    }
  }
}
</style>
